import {AppLayout} from 'layouts/AppLayout'
import {Navigation} from './Navigation'
import {Navigate, Route, Routes} from 'react-router-dom'
import {Backdrop} from 'components/backdrop/Backdrop'
import {NavigationContextProvider} from './NavigationContext'
import {DistributorRouter} from 'modules/distributor/Router'
import {ResellerRouter} from 'modules/reseller/Router'
import {BusinessRouter} from 'modules/business/Router'
import {NotFound} from 'modules/core/NotFound'
import {SuperAdmins} from 'modules/super-admin/SuperAdmins'
import {DefaultRoute} from 'utility/utility'
import { DashboardRouter } from './Router'
import { ExportRouter } from 'modules/export/Router'
import { AuthGate } from 'modules/authentication/AuthGate'
import { requireAuth } from 'modules/authentication/components/requireAuth'

const styles = {
  height: '100%',
  position: 'relative'
}

export const Dashboard = requireAuth(() => {
  return (
    <AuthGate>
      <AppLayout>
        <div id="main-page-content" style={styles}>
          <Backdrop>
            <NavigationContextProvider>
              <Navigation />
              <div className="vw-dashboard__main__content">
                <div className="vw-dashboard__main__content__overlay"></div>

                <Routes>
                  <Route path="/" element={<Navigate to={DefaultRoute()} replace />} />

                  <Route path="/distributor/*" element={<DistributorRouter />} />
                  <Route path="/reseller/*" element={<ResellerRouter />} />
                  <Route path="/business/*" element={<BusinessRouter />} />
                  <Route path="/super-admin/*" element={<SuperAdmins />} />
                  <Route path="/dashboard/*" element={<DashboardRouter />} />
                  <Route path="/export/*" element={<ExportRouter />} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </NavigationContextProvider>
          </Backdrop>
        </div>
      </AppLayout>
    </AuthGate>
  )
})
